const protocolsToRemove = ['http', 'https'];

/**
 * Remove http:// and https:// from the beginning of the url
 */
export function formatToHumanReadableUrl(url: string) {
  for (const protocol of protocolsToRemove) {
    const start = `${protocol}://`;

    if (url.startsWith(start)) return url.substring(start.length);
  }

  return url;
}
